import React from "react";
import { Container, Button, Card, Table } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

const OrderConfirmed = () => {
  const location = useLocation();
  const { order } = location.state || {};

  if (!order) {
    return (
      <div>
        <Header />
        <Container className="text-center py-5">
          <p className="fs-5">No order details available.</p>
          <NavLink to="/" className="btn btn-dark">Go Home</NavLink>
        </Container>
        <Footer />
      </div>
    );
  }

  // ✅ FIXED: Correct fields from Checkout address
  const customerName =
    `${order.address?.firstName || ""} ${order.address?.lastName || ""}`.trim() ||
    "Customer Name";

  const phone = order.address?.phone || "N/A";

  const addressText = [
    order.address?.street,
    order.address?.city,
    order.address?.state,
    order.address?.pincode,
  ]
    .filter(Boolean)
    .join(", ");

  const deliveryStatus = order.status || "Pending";

  return (
    <div>
      <Header />

      <Container
        className="d-flex justify-content-center align-items-center py-5"
        style={{ minHeight: "100vh" }}
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="w-100"
        >
          <Card
            className="p-4 border-0 shadow-sm rounded-4 mx-auto"
            style={{ maxWidth: "700px" }}
          >
            {/* Confirmation Header */}
            <div className="text-center mb-4">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
                className="mb-3"
              >
                <div
                  className="mx-auto rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    backgroundColor: "#D9C6AA",
                  }}
                >
                  <i
                    className="bi bi-check2"
                    style={{ fontSize: "40px", color: "#7B4B3A" }}
                  ></i>
                </div>
              </motion.div>

              <h3
                className="fw-semibold"
                style={{
                  color: "#A58756",
                  fontFamily: "Poppins",
                  fontWeight: "400",
                }}
              >
                Order Confirmed
              </h3>

              <p className="text-muted">
                You will receive an order confirmation shortly.
              </p>
            </div>

            {/* Delivery Info */}
            <motion.div
              className="border rounded-4 p-3 d-flex align-items-center justify-content-between mb-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <div style={{ flex: 1 }}>
                <p className="mb-1 fw-semibold">Delivering to:</p>
                <p className="mb-1">
                  {customerName} 
                </p>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                  {addressText}
                </p>
                {/* <p className="text-muted mt-1" style={{ fontSize: "14px" }}>
                  Status: <strong>{deliveryStatus}</strong>
                </p> */}
              </div>

              <img
                src="https://www.emoji.co.uk/files/phantom-open-emojis/travel-places-phantom/12675-racing-motorcycle.png"
                alt="delivery"
                style={{ width: "80px", height: "80px" }}
              />
            </motion.div>

            {/* Order Summary */}
            <Card className="p-3 mb-3 border rounded-4">
              <h6 className="fw-semibold mb-3">Order Summary</h6>
              <Table borderless size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td>Subtotal</td>
                    <td className="text-end">₹{order.subtotal.toFixed(2)}</td>
                  </tr>
                  {/* <tr>
                    <td>SGST</td>
                    <td className="text-end">₹{order.sgst.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>CGST</td>
                    <td className="text-end">₹{order.cgst.toFixed(2)}</td>
                  </tr> */}
                  {order.other > 0 && (
                    <tr>
                      <td>Other Charges</td>
                      <td className="text-end">₹{order.other.toFixed(2)}</td>
                    </tr>
                  )}
                  <tr className="fw-bold border-top">
                    <td>Total Amount</td>
                    <td className="text-end">
                      ₹{order.totalAmount.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card>

            {/* Buttons */}
            <div className="text-center mt-3">
              <Button
                as={NavLink}
                to="/orders"
                style={{
                  backgroundColor: "#7B4B3A",
                  border: "none",
                  padding: "10px 25px",
                  fontFamily: "Poppins",
                }}
                className="me-2"
              >
                Order Details
              </Button>

              <Button
                as={NavLink}
                to="/"
                variant="outline-secondary"
                style={{
                  borderColor: "#7B4B3A",
                  color: "#7B4B3A",
                  fontFamily: "Poppins",
                  padding: "10px 25px",
                }}
              >
                Continue Shopping
              </Button>
            </div>
          </Card>
        </motion.div>
      </Container>

      <Footer />
    </div>
  );
};

export default OrderConfirmed;
